import { useEffect, useReducer, useState } from 'react';
import DashboardService from '../../services/dashboardService';
import { useHistory } from 'react-router-dom';
import dashboardServiceSas from '../../services/dashboardServiceSAS';
import dashboardServiceSse from '../../services/dashboardServiceSSE';
import moment from 'moment';
import { firstLastName } from '../../utils/mask';
import dashboardServiceUser from '../../services/dashboardServiceUSER';
import dashboardServiceAcessos from '../../services/dashboardServiceAcessos';
import { useApp } from '../../context/app';
import { hasAdminRole } from '../../utils/hasPermission';
import useAbortableRequest from "../../hooks/useAbortableRequest";

export const opcoes = [
    {
        name: 'Relatórios',
        label: 'relatorios',
        route: 'relatorios',
    },
    {
        name: 'Acessos',
        label: 'acessos',
        route: 'acessos',
    },
    {
        name: 'Agendamentos',
        label: 'agendamentos',
        route: 'agendamentos',
    },
    {
        name: 'Atendimentos SSE',
        label: 'nans',
        route: 'nans',
    },
    {
        name: 'Diagnósticos Realizados',
        label: 'devolutivas',
        route: 'devolutivas',
    },
    {
        name: 'Registros (SAS)',
        label: 'registros-atendimento',
        route: 'registros-atendimento',
    },
    {
        name: 'Usuários',
        label: 'usuarios',
        route: 'usuarios',
    },
    {
        name: 'Recorrências',
        label: 'recorrencias',
        route: 'recorrencias',
    },
];

const DashboardModel = () => {

    const { createAbortController, cancelRequests } = useAbortableRequest();
    const updateFilter = (state, action) => {
        switch (action.type) {
            case 'filters':
                return {...state, filters: action.data};
            default:
                throw new Error();
        }
    };

    const initialValueFilter = {
        filters: {},
    };

    const {filtersDashboard, setFiltersDashboard} = useApp();

    const history = useHistory();
    const [selectedNavBar, setSelectedNavBar] = useState(0);
    const [data, setData] = useState({});
    const [resumo, setResumo] = useState({});
    const [isLoading, setIsLoading] = useState({
        data: true,
        destaque: true,
    });
    const [isCleanerCache, setIsCleanerCache] = useState(false);

    // START ResgistroSAS LOADING Area------------------------------------------------------------------
    const [isLoadingSas, setIsLoadingSas] = useState(true);
    const [isLoadingUserUnico, setIsLoadingUserUnico] = useState(true);
    const [isLoadingPerfilUser, setIsLoadingPerfilUser] = useState(true);
    const [isLoadingPorcemPerfilUserUnico, setIsLoadingPorcemPerfilUserUnico] =
        useState(true);
    const [isLoadingMediaAtendiUser, setIsLoadingMediaAtendiUser] =
        useState(true);
    const [isLoadingMediaAtendUserPf, setIsLoadingMediaAtendUserPf] =
        useState(true);
    const [isLoadingMediaAtendUserPj, setIsLoadingMediaAtendUserPj] =
        useState(true);
    const [isLoadingPorteTipoInstru, setIsLoadingPorteTipoInstru] =
        useState(true);
    const [isLoadingAtendPorte, setIsLoadingAtendPorte] = useState(true);
    const [isLoadingMediaAtendPorte, setIsLoadingMediaAtendPorte] =
        useState(true);
    const [isLoadingAtendHora, setIsLoadingAtendHora] = useState(true);
    const [isLoadingAtendUF, setIsLoadingAtendUF] = useState(true);

    const [isLoadingAPC, setIsLoadingAPC] = useState(true);
    const [isLoadingAPS, setIsLoadingAPS] = useState(true);
    const [isLoadingAPB, setIsLoadingAPB] = useState(true);
    const [isLoadingAPM, setIsLoadingAPM] = useState(true);
    const [isLoadingAPA, setIsLoadingAPA] = useState(true);
    const [isLoadingAPD, setIsLoadingAPD] = useState(true);
    const [isLoadingAPL, setIsLoadingAPL] = useState(true);
    const [isLoadingAPR, setIsLoadingAPR] = useState(true);
    const [isLoadingAPE, setIsLoadingAPE] = useState(true);
    const [isLoadingAPN, setIsLoadingAPN] = useState(true);
    const [isLoadingAPF, setIsLoadingAPF] = useState(true);
    const [isLoadingAPO, setIsLoadingAPO] = useState(true);
    const [isLoadingStatusEnvioSAS, setIsLoadingStatusEnvioSAS] = useState(true);
    const [isLoadingPorcemEnvioSAS, setIsLoadingPorcemEnvioSAS] = useState(true);
    const [isLoadingEnvioInstrumentoSAS, setIsLoadingEnvioInstrumentoSAS] =
        useState(true);
    // END ResgistroSAS LOADING Area------------------------------------------------------------------

    // START AtendimentosSSE LOADING Area------------------------------------------------------------
    const [isLoadingUsuariosApp, setIsLoadingUsuariosApp] = useState(true);
    const [isLoadingTotal, setIsLoadingTotal] = useState(true);
    const [isLoadingStatusEnvio, setIsLoadingStatusEnvio] = useState(true);
    const [isLoadingPorte, setIsLoadingPorte] = useState(true);
    const [isLoadingPorteMei, setIsLoadingPorteMei] = useState(true);
    const [isLoadingPorteMe, setIsLoadingPorteMe] = useState(true);
    const [isLoadingPorcemUsuariosApp, setIsLoadingPorcemUsuariosApp] =
        useState(true);
    const [isLoadingPorteEpp, setIsLoadingPorteEpp] = useState(true);
    const [isLoadingPorcemStatusEnvio, setIsLoadingPorcemStatusEnvio] =
        useState(true);
    const [isLoadingHora, setIsLoadingHora] = useState(true);
    const [isLoadingHoje, setIsLoadingHoje] = useState(true);
    const [isLoadingDia, setIsLoadingDia] = useState(true);
    const [isLoadingUfCidadeAtendente, setIsLoadingUfCidadeAtendente] =
        useState(true);
    const [isLoadingSemAnotacao, setIsLoadingSemAnotacao] = useState(true);
    const [isLoadingSemPlanoAcao, setIsLoadingSemPlanoAcao] = useState(true);
    const [isLoadingSemFoto, setIsLoadingSemFoto] = useState(true);
    const [isLoadingSemArquivo, setIsLoadingSemArquivo] = useState(true);
    // END AtendimentosSSE LOADING Area--------------------------------------------------------------

    // START Usuários LOADING Area------------------------------------------------------------
    const [isLoadingTotalUser, setIsLoadingTotalUser] = useState(true);
    const [isLoadingNovosUser, setIsLoadingNovosUser] = useState(true);
    const [isLoadingPfUser, setIsLoadingPfUser] = useState(true);
    const [isLoadingPjUser, setIsLoadingPjUser] = useState(true);
    const [isLoadingPjMeiUser, setIsLoadingPjMeiUser] = useState(true);
    const [isLoadingPjMeUser, setIsLoadingPjMeUser] = useState(true);
    const [isLoadingPjEppUser, setIsLoadingPjEppUser] = useState(true);
    const [isLoadingPjOutrosUser, setIsLoadingPjOutrosUser] = useState(true);
    const [isLoadingAtivosAgoraUser, setIsLoadingAtivosAgoraUser] =
        useState(true);
    const [isLoadingAtivosAgoraPfUser, setIsLoadingAtivosAgoraPfUser] =
        useState(true);
    const [isLoadingAtivosAgoraPjUser, setIsLoadingAtivosAgoraPjUser] =
        useState(true);
    const [isLoadingUfUser, setIsLoadingUfUser] = useState(true);
    // END Usuários LOADING Area------------------------------------------------------------

    // START ACESSOS LOADING Area------------------------------------------------------------
    const [isLoadingTotalAcessos, setIsLoadingTotalAcessos] = useState(true);
    const [isLoadingUsuariosUnicosAcessos, setIsLoadingUsuariosUnicosAcessos] =
        useState(true);
    const [isLoadingMediaUsuarioAcessos, setIsLoadingMediaUsuarioAcessos] =
        useState(true);
    const [isLoadingDistribuicaoDiaAcessos, setIsLoadingDistribuicaoDiaAcessos] =
        useState(true);
    const [isLoadingPerfilUsuariosAcessos, setIsLoadingPerfilUsuariosAcessos] =
        useState(true);
    const [
        isLoadingPorcemPerfilUserAcessos,
        setIsLoadingPorcemPerfilUserAcessos,
    ] = useState(true);
    const [isLoadingPorteAcessos, setIsLoadingPorteAcessos] = useState(true);
    const [isLoadingTempoMedioAcessos, setIsLoadingTempoMedioAcessos] =
        useState(true);
    const [isLoadingUfAcessos, setIsLoadingUfAcessos] = useState(true);
    const [isLoadingUfUnicoAcessos, setIsLoadingUfUnicoAcessos] = useState(true);
    // END ACESSOS LOADING Area--------------------------------------------------------------

    // START RECORRENCIAS LOADING Area------------------------------------------------------------
    const [isLoadingRecorrenciaPjSse, setIsLoadingRecorrenciaPjSse] =
        useState(true);
    const [isLoadingRecorrenciaPjSas, setIsLoadingRecorrenciaPjSas] =
        useState(true);
    const [isLoadingRecorrenciaPjMeiSas, setIsLoadingRecorrenciaPjMeiSas] =
        useState(true);
    const [isLoadingRecorrenciaPjMeSas, setIsLoadingRecorrenciaPjMeSas] =
        useState(true);
    const [isLoadingRecorrenciaPjEppSas, setIsLoadingRecorrenciaPjEppSas] =
        useState(true);
    // END RECORRENCIAS LOADING Area------------------------------------------------------------

    const [isError, setError] = useState(false);
    const [filters, setFilters] = useReducer(updateFilter, initialValueFilter);
    const [filterOptions, setFiltersOptions] = useState({});
    const [cidades, setCidades] = useState([]);
    const [firstRender, setFirstRender] = useState(true);
    const [isAdmin, setIsAdmin] = useState(null);

    //START RegistroSAS dashboard state area-----------------------------------------------------------
    const [registroSas, setRegistroSas] = useState([]);
    const [atendimentosHora, setAtendimentosHora] = useState({});
    const [usuariosUnicos, setUsuariosUnicos] = useState({});
    const [perfilUsuario, setPerfilUsuario] = useState({});
    const [porcemPerfilUsuarioUnico, setPorcemPerfilUsuarioUnico] = useState({});
    const [mediaAtendimentoUsuario, setMediaAtendimentoUsuario] = useState({});
    const [mediaAtendimentoUsuarioPf, setMediaAtendimentoUsuarioPf] = useState(
        {}
    );
    const [mediaAtendimentoUsuarioPj, setMediaAtendimentoUsuarioPj] = useState(
        {}
    );
    const [porteTipoInstrumento, setPorteTipoInstrumento] = useState({});
    const [atendimentoPorte, setAtendimentoPorte] = useState({});
    const [mediaAtendimentoPorte, setMediaAtendimentoPorte] = useState({});
    const [atendimentoUf, setAtendimentoUf] = useState({});
    const [tipoAtendimentoAPC, setTipoAtendimentoAPC] = useState({});
    const [tipoAtendimentoAPS, setTipoAtendimentoAPS] = useState({});
    const [tipoAtendimentoAPB, setTipoAtendimentoAPB] = useState({});
    const [tipoAtendimentoAPM, setTipoAtendimentoAPM] = useState({});
    const [tipoAtendimentoAPA, setTipoAtendimentoAPA] = useState({});
    const [tipoAtendimentoAPD, setTipoAtendimentoAPD] = useState({});
    const [tipoAtendimentoAPL, setTipoAtendimentoAPL] = useState({});
    const [tipoAtendimentoAPR, setTipoAtendimentoAPR] = useState({});
    const [tipoAtendimentoAPE, setTipoAtendimentoAPE] = useState({});
    const [tipoAtendimentoAPN, setTipoAtendimentoAPN] = useState({});
    const [tipoAtendimentoAPF, setTipoAtendimentoAPF] = useState({});
    const [tipoAtendimentoAPO, setTipoAtendimentoAPO] = useState({});
    const [statusEnvioSAS, setStatusEnvioSAS] = useState({});
    const [porcemEnvioSAS, setPorcemEnvioSAS] = useState({});
    const [envioInstrumentoSAS, setEnvioInstrumentoSAS] = useState({});
    // END ResgistroSAS dashboard state area-------------------------------------------------------

    // START AtendimentosSSE Dashboard state area----------------------------------------------------
    const [usuariosApp
        // , setUsuariosApp
    ] = useState({});
    const [total, setTotal] = useState({});
    const [statusEnvio
        // ,setStatusEnvio
    ] = useState({});
    const [porte, setPorte] = useState({});
    const [porteMei,
        // setPorteMei
    ] = useState({});
    const [porteMe,
        // setPorteMe
    ] = useState({});
    const [porteEpp,
        // setPorteEpp
    ] = useState({});
    const [porcemUsuariosApp, setPorcemUsuariosApp] = useState({});
    const [porcemStatusEnvio, setPorcemStatusEnvio] = useState({});
    const [hora,
        // setHora
    ] = useState({});
    const [hoje, setHoje] = useState({});
    const [dia,
        // setDia
    ] = useState({});
    const [ufCidadeAtendente, setUfCidadeAtendente] = useState({});
    const [semAnotacao, setSemAnotacao] = useState({});
    const [semPlanoAcao, setSemPlanoAcao] = useState({});
    const [semFoto, setSemFoto] = useState({});
    const [semArquivo, setSemArquivo] = useState({});
    // END AtendimentosSSE Dashboard state area------------------------------------------------------

    // START USUARIOS Dashboard state area----------------------------------------------------
    const [totalUser, setTotalUser] = useState({});
    const [novosUser, setNovosUser] = useState({});
    const [PfUser, setPfUser] = useState({});
    const [PjUser, setPjUser] = useState({});
    const [PjMeiUser, setPjMeiUser] = useState({});
    const [PjMeUser, setPjMeUser] = useState({});
    const [PjEppUser, setPjEppUser] = useState({});
    const [PjOutrosUser, setPjOutrosUser] = useState({});
    const [AtivosAgoraUser, setAtivosAgoraUser] = useState({});
    const [AtivosAgoraPfUser, setAtivosAgoraPfUser] = useState({});
    const [AtivosAgoraPjUser, setAtivosAgoraPjUser] = useState({});
    const [ufUser, setUfUser] = useState({});
    // END USUARIOS Dashboard state area----------------------------------------------------

    // START ACESSOS Dashboard state area----------------------------------------------------
    const [totalAcessos, setTotalAcessos] = useState({});
    const [usuariosUnicosAcessos, setUsuariosUnicosAcessos] = useState({});
    const [mediaUsuarioAcessos, setmediaUsuarioAcessos] = useState({});
    const [distribuicaoDiaAcessos, setdistribuicaoDiaAcessos] = useState({});
    const [perfilUsuarioAcessos, setPerfilUsuarioAcessos] = useState({});
    const [porcemPerfilUserAcessos, setPorcemPerfilUserAcessos] = useState({});
    const [porteAcessos, setporteAcessos] = useState({});
    const [tempoMedioAcessos, settempoMedioAcessos] = useState({});
    const [ufAcessos, setUfAcessos] = useState({});
    // END ACESSOS Dashboard state area------------------------------------------------------

    // START RECORRENCIAS Dashboard state area------------------------------------------------------
    const [recorrenciaPjSas, setRecorrenciaPjSas] = useState({});
    const [recorrenciaPjMeiSas, setRecorrenciaPjMeiSas] = useState({});
    const [recorrenciaPjMeSas, setRecorrenciaPjMeSas] = useState({});
    const [recorrenciaPjEppSas, setRecorrenciaPjEppSas] = useState({});
    const [recorrenciaPjSse, setRecorrenciaPjSse] = useState({});
    // END RECORRENCIAS Dashboard state area------------------------------------------------------


    // const setAbortController = useAbortControllerStore((state) => state.setAbortController);
    // const cancelRequest = useAbortControllerStore((state) => state.cancelRequest);

    const updateSelectedBar = (value) => setSelectedNavBar(value);
    const setAllLoadingTrue = (value) => {
        return (
            //START SET LOADING TRUE SAS-----------------------------------------------------------------------
            setIsLoadingSas(value),
                setIsLoadingUserUnico(value),
                setIsLoadingPerfilUser(value),
                setIsLoadingPorcemPerfilUserUnico(value),
                setIsLoadingMediaAtendiUser(value),
                setIsLoadingMediaAtendUserPf(value),
                setIsLoadingMediaAtendUserPj(value),
                setIsLoadingPorteTipoInstru(value),
                setIsLoadingAtendPorte(value),
                setIsLoadingMediaAtendPorte(value),
                setIsLoadingAtendHora(value),
                setIsLoadingAtendUF(value),
                setIsLoadingAPC(value),
                setIsLoadingAPS(value),
                setIsLoadingAPB(value),
                setIsLoadingAPM(value),
                setIsLoadingAPA(value),
                setIsLoadingAPD(value),
                setIsLoadingAPL(value),
                setIsLoadingAPR(value),
                setIsLoadingAPE(value),
                setIsLoadingAPN(value),
                setIsLoadingAPF(value),
                setIsLoadingAPO(value),
                setIsLoadingStatusEnvioSAS(value),
                setIsLoadingPorcemEnvioSAS(value),
                setIsLoadingEnvioInstrumentoSAS(value),
                setIsLoadingRecorrenciaPjSas(value),
                setIsLoadingRecorrenciaPjMeiSas(value),
                setIsLoadingRecorrenciaPjMeSas(value),
                setIsLoadingRecorrenciaPjEppSas(value),
                //END SET LOADING TRUE SAS-----------------------------------------------------------------------

                //START SET LOADING TRUE SSE-----------------------------------------------------------------------
                setIsLoadingUsuariosApp(value),
                setIsLoadingTotal(value),
                setIsLoadingStatusEnvio(value),
                setIsLoadingPorte(value),
                setIsLoadingPorteMei(value),
                setIsLoadingPorteMe(value),
                setIsLoadingPorcemUsuariosApp(value),
                setIsLoadingPorteEpp(value),
                setIsLoadingPorcemStatusEnvio(value),
                setIsLoadingHora(value),
                setIsLoadingHoje(value),
                setIsLoadingDia(value),
                setIsLoadingUfCidadeAtendente(value),
                setIsLoadingRecorrenciaPjSse(value),
                setIsLoadingSemAnotacao(value),
                setIsLoadingSemPlanoAcao(value),
                setIsLoadingSemFoto(value),
                setIsLoadingSemArquivo(value),
                //END SET LOADING TRUE SSE-----------------------------------------------------------------------

                //START SET LOADING TRUE USER-----------------------------------------------------------------------
                setIsLoadingTotalUser(value),
                setIsLoadingNovosUser(value),
                setIsLoadingPfUser(value),
                setIsLoadingPjUser(value),
                setIsLoadingPjMeiUser(value),
                setIsLoadingPjMeUser(value),
                setIsLoadingPjEppUser(value),
                setIsLoadingPjOutrosUser(value),
                setIsLoadingAtivosAgoraUser(value),
                setIsLoadingAtivosAgoraPfUser(value),
                setIsLoadingAtivosAgoraPjUser(value),
                setIsLoadingUfUser(value),
                //END SET LOADING TRUE USER-----------------------------------------------------------------------

                //START SET LOADING TRUE ACESSOS-----------------------------------------------------------------------
                setIsLoadingTotalAcessos(value),
                setIsLoadingUsuariosUnicosAcessos(value),
                setIsLoadingMediaUsuarioAcessos(value),
                setIsLoadingDistribuicaoDiaAcessos(value),
                setIsLoadingPerfilUsuariosAcessos(value),
                setIsLoadingPorcemPerfilUserAcessos(value),
                setIsLoadingPorteAcessos(value),
                setIsLoadingTempoMedioAcessos(value),
                setIsLoadingUfAcessos(value),
                setIsLoadingUfUnicoAcessos(value)
            //END SET LOADING TRUE ACESSOS-----------------------------------------------------------------------
        );
    };

    // clean cache
    const cleanCache = async (controller) => {
        setIsCleanerCache(true);
        await DashboardService.cleanCache();

        setTimeout(() => {
            setIsCleanerCache(false);
            cleanFilters();
        }, 2300);
    };

    // Cleaning filters
    const cleanFilters = () => {
        return new Promise((resolve, reject) => {
            setFirstRender(true);
            setCidades([]);
            setAllLoadingTrue(true);
            const dataModalFilterStart = moment()
                .startOf('year')
                .format('YYYY-MM-DD')
                .split('-');
            const dataModalFilterEnd = moment().format('YYYY-MM-DD').split('-');
            setFilters({
                type: 'filters',
                data: {
                    ...filters.filters,
                    ufs: undefined,
                    cidades: undefined,
                    dataInicial: `${dataModalFilterStart[0]}-${dataModalFilterStart[1]}-${dataModalFilterStart[2]}`,
                    dataFinal: `${dataModalFilterEnd[0]}-${dataModalFilterEnd[1]}-${dataModalFilterEnd[2]}`,
                },
            });
            resolve(true);
        });
    };

    // GET Cidades and Set loding True
    const getCidades = async (id) => {
        if (id !== '' && filterOptions.ufs) {
            const uf = filterOptions.ufs.find((u) => u.id === parseInt(id));
            const cidadesByUF = filterOptions.cidades.filter(
                (cd) => cd.uf.id === parseInt(id)
            );

            setFiltersDashboard({
                ...filtersDashboard,
                ufs: [uf],
                ufValueSelect: uf,
            });
            setFilters({
                type: 'filters',
                data: {
                    ...filters.filters,
                    ufs: [uf],
                },
            });
            setCidades(cidadesByUF ?? []);
            setAllLoadingTrue(true);
            setFirstRender(true);
        } else {
            setFilters({
                type: 'filters',
                data: {...filters.filters, ufs: undefined, cidades: undefined},
            });
            setCidades([]);
        }
    };

    // START dates filters area-------------------------------------------------------------
    let diaInicio = null;
    let mesInicio = null;
    let anoInicio = null;
    let diaFim = null;
    let mesFim = null;
    let anoFim = null;

    function handleApplyRangeDate(selectedDayRange) {
        selectedDayRange?.from?.day < 10
            ? (diaInicio = `0${selectedDayRange?.from?.day}`)
            : (diaInicio = selectedDayRange?.from?.day);
        selectedDayRange?.from?.month < 10
            ? (mesInicio = `0${selectedDayRange?.from?.month}`)
            : (mesInicio = selectedDayRange?.from?.month);
        anoInicio = selectedDayRange?.from?.year;

        selectedDayRange?.to?.day < 10
            ? (diaFim = `0${selectedDayRange?.to?.day}`)
            : (diaFim = selectedDayRange?.to?.day);
        selectedDayRange?.to?.month < 10
            ? (mesFim = `0${selectedDayRange?.to?.month}`)
            : (mesFim = selectedDayRange?.to?.month);
        anoFim = selectedDayRange?.to?.year;

        setFiltersDashboard({
            ...filtersDashboard,
            dataInicial: `${anoInicio}-${mesInicio}-${diaInicio}`,
            dataFinal: `${anoFim}-${mesFim}-${diaFim}`,
        });
        setFilters({
            type: 'filters',
            data: {
                ...filters.filters,
                dataInicial: `${anoInicio}-${mesInicio}-${diaInicio}`,
                dataFinal: `${anoFim}-${mesFim}-${diaFim}`,
            },
        });
        setAllLoadingTrue(true);
        setFirstRender(true);
    }

    // END dates filters area-------------------------------------------------------------

    // GET DATA OTHER DASHs
    const getData = async (controller) => {
        if (
            opcoes[selectedNavBar].label === 'nans' ||
            opcoes[selectedNavBar].label === 'registros-atendimento' ||
            opcoes[selectedNavBar].label === 'usuarios' ||
            opcoes[selectedNavBar].label === 'acessos' ||
            opcoes[selectedNavBar].label === 'relatorios' ||
            opcoes[selectedNavBar].label === 'recorrencias'
        ) {
            return;
        } else {
            const resp = await DashboardService.getAcessos(
                opcoes[selectedNavBar].label,
                filters.filters
            );
            if (resp?.status !== 200) {
                setError(true);
            } else {
                setData(resp?.data ?? {});
                setTimeout(() => {
                    setIsLoading({...isLoading, data: false});
                }, 300);
            }
        }

        return setFirstRender(false);
    };

    // START GET DATA SAS AREA-----------------------------------------------------------------------
    const getDataRegistroSas = async (controller) => {
        const resp = await dashboardServiceSas.getRegistrosSAS(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setRegistroSas({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingSas(false);
        }
    };

    const getUsuariosUnicos = async (controller) => {

        const resp = await dashboardServiceSas.getUsuariosUnicos(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setUsuariosUnicos({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingUserUnico(false);
        }
    };

    const getPerfilUsuario = async (controller) => {

        const resp = await dashboardServiceSas.getPerfilUsuario(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push(
                    {
                        name: 'PF',
                        dia: moment(dt.data).format('DD'),
                        total: dt.totalPf,
                    },
                    {
                        name: 'PJ',
                        dia: moment(dt.data).format('DD'),
                        total: dt.totalPj,
                    }
                );
                dataInfo2.push(
                    {
                        name: 'PF',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.totalPf,
                    },
                    {
                        name: 'PJ',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.totalPj,
                    }
                );
            });

            setPerfilUsuario({
                atendimentos: dataInfo,
                porcentagemPf: resp.data.porcentagemPf,
                porcentagemPj: resp.data.porcentagemPj,
                data: dataInfo2,
            });

            setIsLoadingPerfilUser(false);
        }
    };

    const getPorcentagemPerfilUsuarioUnico = async (controller) => {
        const resp = await dashboardServiceSas.getPorcentagemPerfilUsuarioUnico(
            filters.filters,
            controller
        );
        if (resp?.data) {
            setPorcemPerfilUsuarioUnico({
                porcentagemPf: resp.data.porcentagemPf,
                porcentagemPj: resp.data.porcentagemPj,
                totalPf: resp.data.totalPf,
                totalPj: resp.data.totalPj,
            });
            setIsLoadingPorcemPerfilUserUnico(false);
        }
    };

    const getMediaAtendimentoUsuario = async (controller) => {
        const resp = await dashboardServiceSas.getMediaAtendimentoUsuario(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setMediaAtendimentoUsuario({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingMediaAtendiUser(false);
        }
    };

    const getMediaAtendimentoUsuarioPf = async (controller) => {
        const resp = await dashboardServiceSas.getMediaAtendimentoUsuarioPf(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setMediaAtendimentoUsuarioPf({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingMediaAtendUserPf(false);
        }
    };

    const getMediaAtendimentoUsuarioPj = async (controller) => {
        const resp = await dashboardServiceSas.getMediaAtendimentoUsuarioPj(
            filters.filters,
controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setMediaAtendimentoUsuarioPj({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingMediaAtendUserPj(false);
        }
    };

    const getPorteTipoInstrumento = async (controller) => {
        const resp = await dashboardServiceSas.getPorteTipoInstrumento(
            filters.filters,
            controller
        );

        if (resp?.data) {
            setPorteTipoInstrumento(
                resp.data.map((item) => {
                    switch (item.descricao) {
                        case 'Orientação Técnica a Distância':
                            item.descricao = 'OTD';
                            break;
                        case 'Informação a Distância':
                            item.descricao = 'IAD';
                            break;
                        case 'Consultoria':
                            item.descricao = 'CON.';
                            break;

                        default:
                            break;
                    }
                    return item;
                })
            );
            setIsLoadingPorteTipoInstru(false);
        }
    };

    const getAtendimentosPorte = async (controller) => {
        const resp = await dashboardServiceSas.getAtendimentosPorte(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    sigla: dt.sigla,
                    total: dt.total,
                });
                dataInfo2.push({
                    siglaModal: dt.sigla,
                    sigla: dt.sigla,
                    total: dt.total,
                });
            });
            // eslint-disable-next-line no-unused-vars
            // const removeValues = dataInfo.splice(3, 2);
            setAtendimentoPorte({
                atendimentos: dataInfo,
                total: resp.data.total,
                slModal: dataInfo2,
            });
            setIsLoadingAtendPorte(false);
        }
    };

    const getMediaAtendimentosPorte = async (controller) => {
        const resp = await dashboardServiceSas.getMediaAtendimentosPorte(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    sigla: dt.sigla,
                    média: dt.total,
                });
                dataInfo2.push({
                    siglaModal: dt.sigla,
                    sigla: dt.sigla,
                    média: dt.total,
                });
            });
            setMediaAtendimentoPorte({
                atendimentos: dataInfo,
                média: resp.data.total,
                slModal: dataInfo2,
            });
            setIsLoadingMediaAtendPorte(false);
        }
    };

    const getAtendimentosHora = async (controller) => {

        const resp = await dashboardServiceSas.getAtendimentosHora(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentosHora.forEach((dt) => {
                dataInfo.push({
                    total: dt.total,
                    hora: dt.hora,
                });
                dataInfo2.push({
                    horaModal: dt.hora,
                    total: dt.total,
                    hora: dt.hora,
                });
            });

            setAtendimentosHora({
                atendimentosHora: dataInfo,
                total: resp.data.total,
                horaModal: dataInfo2,
            });
            setIsLoadingAtendHora(false);
        }
    };

    const getAtendimentosUf = async (controller) => {

        const resp = await dashboardServiceSas.getAtendimentosUf(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let dataInfoUF = [];
            resp.data.atendimentosUnicos.forEach((dt) => {
                dataInfo.push({
                    uf: dt.uf,
                    total: dt.total,
                });
                dataInfoUF.push({
                    sigleUF: dt.uf,
                    uf: dt.uf,
                    total: dt.total,
                });
            });

            let dataInfo2 = [];
            let dataInfoUF2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo2.push({
                    uf: dt?.uf,
                    total: dt?.total,
                });
                dataInfoUF2.push({
                    sigleUF: dt.uf,
                    uf: dt.uf,
                    total: dt.total,
                });
            });
            setAtendimentoUf({
                atendimentosUnicos: dataInfo,
                atendimentos: dataInfo2,
                descUf: dataInfoUF,
                descUf2: dataInfoUF2,
            });
            // setTimeout(() => {
            // }, 7000);
            setIsLoadingAtendUF(false);
        }
    };

    const getTipoAtendimentoAPC = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPC(
            filters.filters,
controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPC({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPC(false);
        }
    };
    const getTipoAtendimentoAPS = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPS(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPS({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPS(false);
        }
    };
    const getTipoAtendimentoAPB = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPB(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPB({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPB(false);
        }
    };
    const getTipoAtendimentoAPM = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPM(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPM({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPM(false);
        }
    };
    const getTipoAtendimentoAPA = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPA(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPA({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPA(false);
        }
    };
    const getTipoAtendimentoAPD = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPD(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPD({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPD(false);
        }
    };
    const getTipoAtendimentoAPL = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPL(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPL({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPL(false);
        }
    };
    const getTipoAtendimentoAPR = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPR(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPR({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPR(false);
        }
    };
    const getTipoAtendimentoAPE = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPE(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPE({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPE(false);
        }
    };
    const getTipoAtendimentoAPN = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPN(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPN({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAPN(false);
        }
    };

    const getTipoAtendimentoAPF = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPF(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPF({
                atendimentos: dataInfo,
                total: resp.data.total,
                contaCorrente: resp.data.contaCorrente,
                maquininha: resp.data.maquininha,
                servicosContabeis: resp.data.servicosContabeis,
                data: date,
            });
            setIsLoadingAPF(false);
        }
    };
    const getTipoAtendimentoAPO = async (controller) => {
        const resp = await dashboardServiceSas.getTipoAtendimentoAPO(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTipoAtendimentoAPO({
                atendimentos: dataInfo,
                total: resp.data.total,
                oportunidade: resp.data.oportunidade,
                melhorLocal: resp.data.melhorLocal,
                data: date,
            });
            setIsLoadingAPO(false);
        }
    };

    const getStatusEnvioSAS = async (controller) => {

        const resp = await dashboardServiceSas.getStatusEnvioSAS(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push(
                    {
                        name: 'enviados',
                        dia: moment(dt.data).format('DD'),
                        total: dt.enviados,
                    },
                    {
                        name: 'não enviados',
                        dia: moment(dt.data).format('DD'),
                        total: dt.naoEnviados,
                    }
                );
                dataInfo2.push(
                    {
                        name: 'enviados',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.enviados,
                    },
                    {
                        name: 'não enviados',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.naoEnviados,
                    }
                );
            });

            setStatusEnvioSAS({
                atendimentos: dataInfo,
                enviados: resp.data.enviados,
                naoEnviados: resp.data.naoEnviados,
                data: dataInfo2,
            });

            setIsLoadingStatusEnvioSAS(false);
        }
    };

    const getPorcentagemEnvioSAS = async (controller) => {

        const resp = await dashboardServiceSas.getPorcemEnvioSAS(filters.filters, controller);
        if (resp?.data) {
            setPorcemEnvioSAS({
                enviados: resp.data.enviados,
                naoEnviados: resp.data.naoEnviados,
                totalEnviados: resp.data.totalEnviados,
                totalNaoEnviados: resp.data.totalNaoEnviados,
            });
            setIsLoadingPorcemEnvioSAS(false);
        }
    };

    const getEnvioInstrumentoSAS = async (controller) => {
        const resp = await dashboardServiceSas.getEnvioInstrumentoSAS(
            filters.filters,
            controller
        );

        if (resp?.data) {
            let dataInfo = [];

            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push(
                    {
                        name: 'enviados',
                        descricao: `${
                            dt.descricao === 'Orientação Técnica a Distância'
                                ? 'OTD'
                                : dt.descricao === 'Informação a Distância'
                                    ? 'IAD'
                                    : 'CON'
                        }`,
                        total: dt.enviados,
                    },
                    {
                        name: 'não enviados',
                        descricao: `${
                            dt.descricao === 'Orientação Técnica a Distância'
                                ? 'OTD'
                                : dt.descricao === 'Informação a Distância'
                                    ? 'IAD'
                                    : 'CON'
                        }`,
                        total: dt.naoEnviados,
                    }
                );
            });

            setEnvioInstrumentoSAS({
                atendimentos: dataInfo,
                enviadosTotal: resp.data.enviados,
                naoEnviadosTotal: resp.data.naoEnviados,
            });

            setIsLoadingEnvioInstrumentoSAS(false);
        }
    };

    const getDataRecorrenciaPjSas = async (controller) => {

        const resp = await dashboardServiceSas.getRecorrenciaPjSas(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setRecorrenciaPjSas({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingRecorrenciaPjSas(false);
        }
    };
    const getDataRecorrenciaPjMeiSas = async (controller) => {
        const resp = await dashboardServiceSas.getRecorrenciaPjMeiSas(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setRecorrenciaPjMeiSas({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingRecorrenciaPjMeiSas(false);
        }
    };
    const getDataRecorrenciaPjMeSas = async (controller) => {
        const resp = await dashboardServiceSas.getRecorrenciaPjMeSas(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setRecorrenciaPjMeSas({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingRecorrenciaPjMeSas(false);
        }
    };
    const getDataRecorrenciaPjEppSas = async (controller) => {
        const resp = await dashboardServiceSas.getRecorrenciaPjEppSas(
            filters.filters,
controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setRecorrenciaPjEppSas({
                atendimentos: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingRecorrenciaPjEppSas(false);
        }
    };
    // END GET DATA SAS AREA-----------------------------------------------------------------------

    // START GET DATA SSE--------------------------------------------------------------------------
    const getDataTotal = async (controller) => {
        try {

            const resp = await dashboardServiceSse.getTotal(filters.filters, controller);
            let dataInfo = [];
            let date = [];
            if (!resp.data) {
                setIsLoadingTotal(false);
                return;
            }
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTotal({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
        } catch (e) {
            console.log('Erro ao obter total de atendimentos:', e)
            setIsLoadingTotal(false);
        } finally {
            setIsLoadingTotal(false);
        }
    };

    const getDataHoje = async (controller) => {

        try {

            const resp = await dashboardServiceSse.getHoje(filters.filters, controller);
            let dataInfo = [];
            let dataInfo2 = [];
            if (!resp?.data) {
                setIsLoadingHoje(false);
                return;
            }
            resp.data.atendimentosHora.forEach((dt) => {
                dataInfo.push({
                    total: dt.total,
                    hora: dt.hora,
                });
                dataInfo2.push({
                    horaModal: dt.hora,
                    total: dt.total,
                    hora: dt.hora,
                });
            });

            setHoje({
                atendimentosHora: dataInfo,
                total: resp.data.total,
                horaModal: dataInfo2,
            });
        } catch (e) {
            console.log('Erro ao obter total de atendimentos:', e)
            setIsLoadingHoje(false);

        } finally {
            setIsLoadingHoje(false);
        }
    };

    // const getDataDistribuicaoDia = async (controller) => {
    //   const resp = await dashboardServiceSse.getHora(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let dataInfo2 = [];
    //     resp.data.atendimentosHora.forEach((dt) => {
    //       dataInfo.push({
    //         total: dt.total,
    //         hora: dt.hora,
    //       });
    //       dataInfo2.push({
    //         horaModal: dt.hora,
    //         total: dt.total,
    //         hora: dt.hora,
    //       });
    //     });
    //
    //     setHora({
    //       atendimentosHora: dataInfo,
    //       total: resp.data.total,
    //       horaModal: dataInfo2,
    //     });
    //     setIsLoadingHora(false);
    //   }
    // };

    // const getDataDiaSemana = async (controller) => {
    //     const abortController = new AbortController();
    //   setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getDia(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let dataInfo2 = [];
    //     resp.data.atendimentosDia.forEach((dt) => {
    //       dataInfo.push({
    //         total: dt.total,
    //         dia: diasSemanaSigla(dt.diaDaSemana),
    //       });
    //       dataInfo2.push({
    //         diaModal: dt.diaDaSemana,
    //         total: dt.total,
    //         dia: diasSemanaSigla(dt.diaDaSemana),
    //       });
    //     });
    //
    //     setDia({
    //       atendimentosDia: dataInfo,
    //       total: resp.data.total,
    //       diaModal: dataInfo2,
    //     });
    //     setIsLoadingDia(false);
    //   }
    // };

    const getPorteEmpresa = async (controller) => {
        try {

            const resp = await dashboardServiceSse.getPorte(filters.filters, controller);
            if (!resp.data) {
                setIsLoadingPorte(false);
                return
            }
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    sigla: dt.sigla,
                    total: dt.total,
                });
                dataInfo2.push({
                    siglaModal: dt.sigla,
                    sigla: dt.sigla,
                    total: dt.total,
                });
            });
            // eslint-disable-next-line no-unused-vars
            // const removeValues = dataInfo.splice(3, 2);
            setPorte({
                atendimentos: dataInfo,
                total: resp.data.total,
                slModal: dataInfo2,
            });
            setIsLoadingPorte(false);

        } catch (e) {
            console.log('Erro getPorteEmpresa:', e)
            setIsLoadingHoje(false);
        } finally {
            setIsLoadingHoje(false);
        }
    };

    // const getDataPorteMei = async (controller) => {
    //     const abortController = new AbortController();
    //   setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getPorteMei(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let date = [];
    //     resp.data.atendimentos.forEach((dt) => {
    //       dataInfo.push({
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //       date.push({
    //         dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //     });
    //     setPorteMei({
    //       atendimentos: dataInfo,
    //       total: resp.data.total,
    //       data: date,
    //     });
    //     setIsLoadingPorteMei(false);
    //   }
    // };
    // const getDataPorteMe = async (controller) => {
    // const abortController = new AbortController();
    // setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getPorteMe(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let date = [];
    //     resp.data.atendimentos.forEach((dt) => {
    //       dataInfo.push({
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //       date.push({
    //         dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //     });
    //     setPorteMe({
    //       atendimentos: dataInfo,
    //       total: resp.data.total,
    //       data: date,
    //     });
    //     setIsLoadingPorteMe(false);
    //   }
    // };
    // const getDataPorteEpp = async (controller) => {
    // const abortController = new AbortController();
    // setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getPorteEpp(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let date = [];
    //     resp.data.atendimentos.forEach((dt) => {
    //       dataInfo.push({
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //       date.push({
    //         dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //         mes: moment(dt.data).format('DD'),
    //         total: dt.total,
    //       });
    //     });
    //     setPorteEpp({
    //       atendimentos: dataInfo,
    //       total: resp.data.total,
    //       data: date,
    //     });
    //     setIsLoadingPorteEpp(false);
    //   }
    // };

    // const getDataStatusEnvio = async (controller) => {
    // const abortController = new AbortController();
    // setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getStatusEnvio(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let dataInfo2 = [];
    //     resp.data.atendimentos.forEach((dt) => {
    //       dataInfo.push(
    //         {
    //           name: 'Enviados',
    //           dia: moment(dt.data).format('DD'),
    //           total: dt.enviados,
    //         },
    //         {
    //           name: 'Não Enviados',
    //           dia: moment(dt.data).format('DD'),
    //           total: dt.naoEnviados,
    //         }
    //       );
    //       dataInfo2.push(
    //         {
    //           name: 'Enviados',
    //           dia: moment(dt.data).format('DD'),
    //           dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //           total: dt.enviados,
    //         },
    //         {
    //           name: 'Não Enviados',
    //           dia: moment(dt.data).format('DD'),
    //           dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //           total: dt.naoEnviados,
    //         }
    //       );
    //     });
    //
    //     setStatusEnvio({
    //       atendimentos: dataInfo,
    //       enviados: resp.data.enviados,
    //       naoEnviados: resp.data.naoEnviados,
    //       data: dataInfo2,
    //     });
    //
    //     setTimeout(() => {
    //       setIsLoadingStatusEnvio(false);
    //     }, 7000);
    //   }
    // };

    const getDataPorcemEnvioSas = async (controller) => {
        const resp = await dashboardServiceSse.getPorcemStatusEnvio(
            filters.filters,
            controller
        );
        if (resp?.data) {
            setPorcemStatusEnvio({
                enviados: resp.data.enviados,
                naoEnviados: resp.data.naoEnviados,
                totalEnviados: resp.data.totalEnviados,
                totalNaoEnviados: resp.data.totalNaoEnviados,
                // totalPf: resp.data.totalPf,
                // totalPj: resp.data.totalPj,
            });
            setIsLoadingPorcemStatusEnvio(false);
        }
    };

    // const getDataUsuariosApp = async (controller) => {
    // const abortController = new AbortController();
    // setAbortController(abortController);
    //   const resp = await dashboardServiceSse.getUsuariosApp(filters.filters, controller);
    //   if (resp?.data) {
    //     let dataInfo = [];
    //     let dataInfo2 = [];
    //     resp.data.usuarios.forEach((dt) => {
    //       dataInfo.push(
    //         {
    //           name: 'Usuários',
    //           dia: moment(dt.data).format('DD'),
    //           total: dt.usuario,
    //         },
    //         {
    //           name: 'Não Usuários',
    //           dia: moment(dt.data).format('DD'),
    //           total: dt.naoUsuario,
    //         }
    //       );
    //       dataInfo2.push(
    //         {
    //           name: 'Usuários',
    //           dia: moment(dt.data).format('DD'),
    //           dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //           total: dt.usuario,
    //         },
    //         {
    //           name: 'Não Usuários',
    //           dia: moment(dt.data).format('DD'),
    //           dataFinal: moment(dt.data).format('DD/MM/YYYY'),
    //           total: dt.naoUsuario,
    //         }
    //       );
    //     });
    //
    //     setUsuariosApp({
    //       usuarios: dataInfo,
    //       usuario: resp.data.usuario,
    //       naoUsuario: resp.data.naoUsuario,
    //       data: dataInfo2,
    //     });
    //
    //     setTimeout(() => {
    //       setIsLoadingUsuariosApp(false);
    //     }, 7000);
    //   }
    // };
    const getDataPorcemUsuariosApp = async (controller) => {
        const resp = await dashboardServiceSse.getPorcemUsuariosApp(
            filters.filters,
            controller
        );
        if (resp?.data) {
            setPorcemUsuariosApp({
                usuario: resp.data.usuario,
                naoUsuario: resp.data.naoUsuario,
                totalUsuario: resp.data.totalUsuario,
                totalNaoUsuario: resp.data.totalNaoUsuario,
            });
            setIsLoadingPorcemUsuariosApp(false);
        }
    };
    const getUfCidadeAtendente = async (controller) => {
        const respUf = await dashboardServiceSse.getUf(filters.filters);

        const respCidades = await dashboardServiceSse.getCidade(filters.filters, controller);
        const respAtendentes = await dashboardServiceSse.getAtendente(
            filters.filters,
 controller
        );

        if (respUf.data && respCidades.data && respAtendentes) {
            let dataInfo = [];
            let dataInfoUF = [];
            respUf.data.forEach((dt) => {
                dataInfo.push({
                    uf: dt.descricao,
                    total: dt.total,
                });
                dataInfoUF.push({
                    sigleUF: dt.descricao,
                    uf: dt.descricao,
                    total: dt.total,
                });
            });

            let dataInfo2 = [];
            let dataInfoCidade = [];
            respCidades.data.forEach((dt) => {
                dataInfo2.push({
                    uf: dt.descricao,
                    total: dt.total,
                });
                dataInfoCidade.push({
                    nameCidade: dt.descricao,
                    uf: dt.descricao,
                    total: dt.total,
                });
            });

            let dataInfo3 = [];
            let dataInfoAtendente = [];
            respAtendentes.data.forEach((dt) => {
                dataInfo3.push({
                    uf: firstLastName(dt.descricao),
                    total: dt.total,
                });
                dataInfoAtendente.push({
                    nameAtendente: firstLastName(dt.descricao),
                    uf: firstLastName(dt.descricao),
                    total: dt.total,
                });
            });

            setUfCidadeAtendente({
                uf: dataInfo,
                descUF: dataInfoUF,
                cidade: dataInfo2,
                descCidade: dataInfoCidade,
                atendente: dataInfo3,
                descAtendente: dataInfoAtendente,
            });
            // setTimeout(() => {
            // }, 7000);
            setIsLoadingUfCidadeAtendente(false);
        }
    };
    const getDataRecorrenciaPjSse = async (controller) => {

        const resp = await dashboardServiceSse.getRecorrenciaPj(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.mediaDiaria.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setRecorrenciaPjSse({
                mediaDiaria: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingRecorrenciaPjSse(false);
        }
    };

    const getDataSemAnotacaoSse = async (controller) => {

        const resp = await dashboardServiceSse.getSemAnotacao(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setSemAnotacao({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingSemAnotacao(false);
        }
    };

    const getDataSemPlanoAcao = async (controller) => {

        const resp = await dashboardServiceSse.getSemPlanoAcao(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setSemPlanoAcao({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingSemPlanoAcao(false);
        }
    };

    const getDataSemFoto = async (controller) => {

        const resp = await dashboardServiceSse.getSemFoto(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setSemFoto({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingSemFoto(false);
        }
    };

    const getDataSemArquivo = async (controller) => {

        const resp = await dashboardServiceSse.getSemArquivo(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setSemArquivo({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingSemArquivo(false);
        }
    };
    // END GET DATA SSE----------------------------------------------------------------------------

    // START GET DATA USUARIOS__________________________________________________________________

    const getDataTotalUser = async (controller) => {

        const resp = await dashboardServiceUser.getTotal(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTotalUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingTotalUser(false);
        }
    };
    const getDataNovosUser = async (controller) => {

        const resp = await dashboardServiceUser.getNovos(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setNovosUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingNovosUser(false);
        }
    };
    const getDataPfUser = async (controller) => {

        const resp = await dashboardServiceUser.getPf(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPfUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPfUser(false);
        }
    };
    const getDataPjUser = async (controller) => {

        const resp = await dashboardServiceUser.getPj(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPjUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPjUser(false);
        }
    };
    const getDataPjMeiUser = async (controller) => {

        const resp = await dashboardServiceUser.getPjMei(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPjMeiUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPjMeiUser(false);
        }
    };
    const getDataPjMeUser = async (controller) => {

        const resp = await dashboardServiceUser.getPjMe(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPjMeUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPjMeUser(false);
        }
    };
    const getDataPjEppUser = async (controller) => {

        const resp = await dashboardServiceUser.getPjEpp(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPjEppUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPjEppUser(false);
        }
    };
    const getDataPjOutrosUser = async (controller) => {

        const resp = await dashboardServiceUser.getPjOutros(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setPjOutrosUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingPjOutrosUser(false);
        }
    };
    const getDataAtivosAgoraUser = async (controller) => {

        const resp = await dashboardServiceUser.getUsuariosAtivos(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setAtivosAgoraUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAtivosAgoraUser(false);
        }
    };
    const getDataAtivosAgoraPfUser = async (controller) => {
        const resp = await dashboardServiceUser.getUsuariosAtivosPf(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setAtivosAgoraPfUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAtivosAgoraPfUser(false);
        }
    };
    const getDataAtivosAgoraPjUser = async (controller) => {
        const resp = await dashboardServiceUser.getUsuariosAtivosPj(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setAtivosAgoraPjUser({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingAtivosAgoraPjUser(false);
        }
    };
    const getDataUfUser = async (controller) => {

        const resp = await dashboardServiceUser.getUf(filters.filters, controller);

        if (resp?.data) {
            let dataInfo = [];
            let dataInfoUF = [];
            resp.data.forEach((dt) => {
                dataInfo.push({
                    uf: dt.descricao,
                    total: dt.total,
                });
                dataInfoUF.push({
                    sigleUF: dt.descricao,
                    uf: dt.descricao,
                    total: dt.total,
                });
            });

            setUfUser({
                uf: dataInfo,
                descUF: dataInfoUF,
            });
            setIsLoadingUfUser(false);
        }
    };

    // END GET DATA USUARIOS__________________________________________________________________

    // START GET DATA ACESSOS-----------------------------------------------------------------
    const getDataTotalAcessos = async (controller) => {

        const resp = await dashboardServiceAcessos.getTotal(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setTotalAcessos({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingTotalAcessos(false);
        }
    };
    const getDataUsuariosUnicosAcessos = async (controller) => {

        const resp = await dashboardServiceAcessos.getUsuariosUnicos(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.total,
                });
            });
            setUsuariosUnicosAcessos({
                atendimentos: dataInfo,
                total: resp.data.total,
                data: date,
            });
            setIsLoadingUsuariosUnicosAcessos(false);
        }
    };

    const getDataMediaUsuarioAcessos = async (controller) => {

        const resp = await dashboardServiceAcessos.getMediaUsuario(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.mediaDiaria.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    média: dt.media,
                });
            });
            setmediaUsuarioAcessos({
                mediaDiaria: dataInfo,
                média: resp.data.media,
                data: date,
            });
            setIsLoadingMediaUsuarioAcessos(false);
        }
    };

    const getDataDistribuicaoDiaAcessos = async (controller) => {
        const resp = await dashboardServiceAcessos.getDistribuicaoDia(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.acessosHora.forEach((dt) => {
                dataInfo.push({
                    total: dt.total,
                    hora: dt.hora,
                });
                dataInfo2.push({
                    horaModal: dt.hora,
                    total: dt.total,
                    hora: dt.hora,
                });
            });

            setdistribuicaoDiaAcessos({
                atendimentosHora: dataInfo,
                horaPico: resp.data.acessosPico.hora,
                total: resp.data.acessosPico.total,
                horaModal: dataInfo2,
            });
            setIsLoadingDistribuicaoDiaAcessos(false);
        }
    };

    const getDataPerfilUsuarioAcessos = async (controller) => {
        const resp = await dashboardServiceAcessos.getPerfilUsuario(
            filters.filters,
            controller
        );
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.perfis.forEach((dt) => {
                dataInfo.push(
                    {
                        name: 'PF',
                        dia: moment(dt.data).format('DD'),
                        total: dt.pessoaFisica,
                    },
                    {
                        name: 'PJ',
                        dia: moment(dt.data).format('DD'),
                        total: dt.pessoaJuridica,
                    }
                );
                dataInfo2.push(
                    {
                        name: 'PF',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.pessoaFisica,
                    },
                    {
                        name: 'PJ',
                        dia: moment(dt.data).format('DD'),
                        dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                        total: dt.pessoaJuridica,
                    }
                );
            });

            setPerfilUsuarioAcessos({
                atendimentos: dataInfo,
                porcentagemPf: resp.data.pessoaFisica,
                porcentagemPj: resp.data.pessoaJuridica,
                data: dataInfo2,
            });

            setIsLoadingPerfilUsuariosAcessos(false);
        }
    };

    const getDataPorcemPerfilUserAcessos = async (controller) => {
        const resp = await dashboardServiceAcessos.getPorcemPerfilUsuario(
            filters.filters,
            controller
        );
        if (resp?.data) {
            setPorcemPerfilUserAcessos({
                porcentagemPf: resp.data.porcentagemPf,
                porcentagemPj: resp.data.porcentagemPj,
            });
            setIsLoadingPorcemPerfilUserAcessos(false);
        }
    };

    const getDataPorteAcessos = async (controller) => {

        const resp = await dashboardServiceAcessos.getPorteEmpresa(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let dataInfo2 = [];
            resp.data.atendimentos.forEach((dt) => {
                dataInfo.push({
                    sigla: dt.sigla,
                    total: dt.total,
                });
                dataInfo2.push({
                    siglaModal: dt.sigla,
                    sigla: dt.sigla,
                    total: dt.total,
                });
            });
            setporteAcessos({
                atendimentos: dataInfo,
                total: resp.data.total,
                slModal: dataInfo2,
            });
            setIsLoadingPorteAcessos(false);
        }
    };

    const getDataTempoMedioAcessos = async (controller) => {

        const resp = await dashboardServiceAcessos.getTempoMedio(filters.filters, controller);
        if (resp?.data) {
            let dataInfo = [];
            let date = [];
            resp.data.medias.forEach((dt) => {
                dataInfo.push({
                    mes: moment(dt.data).format('DD'),
                    total: dt.tempoMedio,
                });
                date.push({
                    dataFinal: moment(dt.data).format('DD/MM/YYYY'),
                    mes: moment(dt.data).format('DD'),
                    total: dt.tempoMedio,
                });
            });
            settempoMedioAcessos({
                atendimentos: dataInfo,
                total: resp.data.tempoMedio,
                data: date,
            });
            setIsLoadingTempoMedioAcessos(false);
        }
    };

    const getDataUfAcessos = async (controller) => {

        const respUf = await dashboardServiceAcessos.getUF(filters.filters, controller);
        const respUfUnicos = await dashboardServiceAcessos.getUfUnico(
            filters.filters,
            controller
        );

        if (respUf?.data && respUfUnicos?.data) {
            let dataInfo = [];
            let dataInfoUF = [];
            respUf.data.forEach((dt) => {
                dataInfo.push({
                    uf: dt.descricao,
                    total: dt.total,
                });
                dataInfoUF.push({
                    sigleUF: dt.descricao,
                    uf: dt.descricao,
                    total: dt.total,
                });
            });

            let dataInfo2 = [];
            let dataInfoUfUnicos = [];
            respUfUnicos.data.forEach((dt) => {
                dataInfo2.push({
                    uf: dt.descricao,
                    total: dt.total,
                });
                dataInfoUfUnicos.push({
                    sigleUF: dt.descricao,
                    uf: dt.descricao,
                    total: dt.total,
                });
            });

            setUfAcessos({
                uf: dataInfo,
                descUF: dataInfoUF,
                ufUnicos: dataInfo2,
                descUfUnicos: dataInfoUfUnicos,
            });
            setIsLoadingUfAcessos(false);
        }
    };
    // END GET DATA ACESSOS-------------------------------------------------------------------

    const getResumo = async (controller) => {
        const resp = await DashboardService.getResumo();
        if (resp?.status !== 200) {
            setError(true);
        } else {
            setResumo(resp?.data ?? {});
            setIsLoading({...isLoading, resumo: false});
        }
    };

    const getFilters = async (route) => {
        const responseFilters = await DashboardService.get(
            `dashboards/${route}/opcoes?consulta=true`
        );
        setFiltersOptions(responseFilters?.data ?? []);
    };

    const checkAdminRole = async (controller) => {
        const adminRole = await hasAdminRole();
        setIsAdmin(adminRole);
        console.log('isAdmin', adminRole);
    };

    // prettier-ignore
    useEffect(_ => {
        getResumo();
        checkAdminRole()
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // prettier-ignore
    useEffect(_ => {
        cleanFilters();
        if (opcoes[selectedNavBar]?.route === 'relatorios') {
            return
        } else {
            let menu = opcoes[selectedNavBar]?.route === 'recorrencias' ? 'registros-atendimento' : opcoes[selectedNavBar]?.route;
            getFilters(menu);
        }

        return () => {
            cancelRequests();
        };
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedNavBar]);

    // prettier-ignore
    useEffect(_ => {
            if (!!firstRender && (selectedNavBar !== 0 || selectedNavBar !== 1 || selectedNavBar !== 3 || selectedNavBar !== 5 || selectedNavBar !== 6 || selectedNavBar !== 7)) {
                getData();
            }
            // https://github.com/facebook/create-react-app/issues/6880
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [filters.filters, firstRender]
    );

    // prettier-ignore
    useEffect(_ => {

            if (!!filters.filters.dataInicial && !!firstRender) {
                const controller = createAbortController()

                if (selectedNavBar === 1) {
                    getDataTotalAcessos(controller);
                    getDataUsuariosUnicosAcessos(controller);
                    getDataMediaUsuarioAcessos(controller);
                    getDataDistribuicaoDiaAcessos(controller);
                    getDataPerfilUsuarioAcessos(controller);
                    getDataPorcemPerfilUserAcessos(controller);
                    getDataPorteAcessos(controller);
                    getDataTempoMedioAcessos(controller);
                    getDataUfAcessos(controller);
                }

                if (selectedNavBar === 3) {
                    getDataTotal(controller);
                    getDataHoje(controller);
                    // getDataDistribuicaoDia();
                    // getDataDiaSemana();
                    getPorteEmpresa(controller);
                    // getDataPorteMei();
                    // getDataPorteMe();
                    // getDataPorteEpp();
                    // getDataUsuariosApp();
                    getDataPorcemUsuariosApp(controller);
                    getDataPorcemEnvioSas(controller);
                    // getDataStatusEnvio();
                    getUfCidadeAtendente(controller);
                    getDataSemAnotacaoSse(controller);
                    getDataSemPlanoAcao(controller);
                    getDataSemFoto(controller);
                    getDataSemArquivo(controller);
                }
                if (selectedNavBar === 5) {
                    getDataRegistroSas(controller);
                    getAtendimentosHora(controller);
                    getUsuariosUnicos(controller);
                    getPerfilUsuario(controller);
                    getMediaAtendimentoUsuario(controller);
                    getMediaAtendimentoUsuarioPf(controller);
                    getMediaAtendimentoUsuarioPj(controller);
                    getPorteTipoInstrumento(controller);
                    getMediaAtendimentosPorte(controller);
                    getAtendimentosPorte(controller);
                    getPorcentagemPerfilUsuarioUnico(controller);
                    getAtendimentosUf(controller);
                    getTipoAtendimentoAPC(controller);
                    getTipoAtendimentoAPS(controller);
                    getTipoAtendimentoAPB(controller);
                    getTipoAtendimentoAPM(controller);
                    getTipoAtendimentoAPA(controller);
                    getTipoAtendimentoAPD(controller);
                    getTipoAtendimentoAPL(controller);
                    getTipoAtendimentoAPR(controller);
                    getTipoAtendimentoAPE(controller);
                    getTipoAtendimentoAPN(controller);
                    getTipoAtendimentoAPF(controller);
                    getTipoAtendimentoAPO(controller);
                    getStatusEnvioSAS(controller);
                    getPorcentagemEnvioSAS(controller);
                    getEnvioInstrumentoSAS(controller);
                }
                if (selectedNavBar === 6) {
                    getDataTotalUser(controller);
                    getDataNovosUser(controller);
                    getDataPfUser(controller);
                    getDataPjUser(controller);
                    getDataPjMeiUser(controller);
                    getDataPjMeUser(controller);
                    getDataPjEppUser(controller);
                    getDataPjOutrosUser(controller);
                    getDataAtivosAgoraUser(controller);
                    getDataAtivosAgoraPfUser(controller);
                    getDataAtivosAgoraPjUser(controller);
                    getDataUfUser(controller);
                }

                if (selectedNavBar === 7) {
                    getDataRecorrenciaPjSas(controller)
                    getDataRecorrenciaPjMeiSas(controller)
                    getDataRecorrenciaPjMeSas(controller)
                    getDataRecorrenciaPjEppSas(controller)
                    getDataRecorrenciaPjSse(controller);
                }

                setFirstRender(false);
            }
        },
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [filters.filters]
    );

    return {
        selectedNavBar,
        updateSelectedBar,
        data,
        isAdmin,
        // START SAS AREA--------------------------------------------------------------------------
        registroSas,
        usuariosUnicos,
        perfilUsuario,
        mediaAtendimentoUsuario,
        mediaAtendimentoUsuarioPf,
        mediaAtendimentoUsuarioPj,
        porteTipoInstrumento,
        mediaAtendimentoPorte,
        porcemPerfilUsuarioUnico,
        atendimentoPorte,
        atendimentosHora,
        atendimentoUf,
        tipoAtendimentoAPC,
        tipoAtendimentoAPS,
        tipoAtendimentoAPB,
        tipoAtendimentoAPM,
        tipoAtendimentoAPA,
        tipoAtendimentoAPD,
        tipoAtendimentoAPL,
        tipoAtendimentoAPR,
        tipoAtendimentoAPE,
        tipoAtendimentoAPN,
        tipoAtendimentoAPF,
        tipoAtendimentoAPO,
        statusEnvioSAS,
        porcemEnvioSAS,
        envioInstrumentoSAS,
        // END SAS AREA--------------------------------------------------------------------------

        // START SSE AREA------------------------------------------------------------------------
        usuariosApp,
        total,
        statusEnvio,
        porte,
        porteMei,
        porteMe,
        porteEpp,
        porcemUsuariosApp,
        porcemStatusEnvio,
        hora,
        hoje,
        dia,
        ufCidadeAtendente,
        semAnotacao,
        semPlanoAcao,
        semFoto,
        semArquivo,
        // END SSE AREA------------------------------------------------------------------------

        // START USUARIOS AREA------------------------------------------------------------------------
        totalUser,
        novosUser,
        PfUser,
        PjUser,
        PjMeiUser,
        PjMeUser,
        PjEppUser,
        PjOutrosUser,
        AtivosAgoraUser,
        AtivosAgoraPfUser,
        AtivosAgoraPjUser,
        ufUser,
        // END USUARIOS AREA------------------------------------------------------------------------

        // START ACESSOS AREA------------------------------------------------------------------------
        totalAcessos,
        usuariosUnicosAcessos,
        mediaUsuarioAcessos,
        distribuicaoDiaAcessos,
        perfilUsuarioAcessos,
        porcemPerfilUserAcessos,
        porteAcessos,
        tempoMedioAcessos,
        ufAcessos,
        // END ACESSOS AREA------------------------------------------------------------------------

        // START RECORRENCIAS AREA-----------------------------------------------------------------------
        recorrenciaPjSse,
        recorrenciaPjSas,
        recorrenciaPjMeiSas,
        recorrenciaPjMeSas,
        recorrenciaPjEppSas,
        // END RECORRENCIAS AREA------------------------------------------------------------------------

        resumo,
        isLoading,
        isError,
        history,
        filterOptions,
        filters,
        cidades,
        setFilters,
        setFirstRender,
        cleanFilters,
        cleanCache,
        getCidades,
        handleApplyRangeDate,
        setAllLoadingTrue,
        isCleanerCache,

        // START LOADING SAS----------------------------------------------------------------
        isLoadingSas,
        isLoadingUserUnico,
        isLoadingPerfilUser,
        isLoadingPorcemPerfilUserUnico,
        isLoadingMediaAtendiUser,
        isLoadingMediaAtendUserPf,
        isLoadingMediaAtendUserPj,
        isLoadingPorteTipoInstru,
        isLoadingAtendPorte,
        isLoadingMediaAtendPorte,
        isLoadingAtendHora,
        isLoadingAtendUF,
        isLoadingAPC,
        isLoadingAPS,
        isLoadingAPB,
        isLoadingAPM,
        isLoadingAPA,
        isLoadingAPD,
        isLoadingAPL,
        isLoadingAPR,
        isLoadingAPE,
        isLoadingAPN,
        isLoadingAPF,
        isLoadingAPO,
        isLoadingStatusEnvioSAS,
        isLoadingPorcemEnvioSAS,
        isLoadingEnvioInstrumentoSAS,
        // END LOADING SAS----------------------------------------------------------------

        // STAR LOADING SSE----------------------------------------------------------------
        isLoadingUsuariosApp,
        isLoadingTotal,
        isLoadingStatusEnvio,
        isLoadingPorte,
        isLoadingPorteMei,
        isLoadingPorteMe,
        isLoadingPorcemUsuariosApp,
        isLoadingPorteEpp,
        isLoadingPorcemStatusEnvio,
        isLoadingHora,
        isLoadingHoje,
        isLoadingDia,
        isLoadingUfCidadeAtendente,
        isLoadingSemAnotacao,
        isLoadingSemPlanoAcao,
        isLoadingSemFoto,
        isLoadingSemArquivo,
        // END LOADING SSE----------------------------------------------------------------

        // STAR LOADING USUARIOS----------------------------------------------------------------
        isLoadingTotalUser,
        isLoadingNovosUser,
        isLoadingPfUser,
        isLoadingPjUser,
        isLoadingPjMeiUser,
        isLoadingPjMeUser,
        isLoadingPjEppUser,
        isLoadingPjOutrosUser,
        isLoadingAtivosAgoraUser,
        isLoadingAtivosAgoraPfUser,
        isLoadingAtivosAgoraPjUser,
        isLoadingUfUser,
        // END LOADING USUARIOS----------------------------------------------------------------

        // STAR LOADING ACESSOS----------------------------------------------------------------
        isLoadingTotalAcessos,
        isLoadingUsuariosUnicosAcessos,
        isLoadingMediaUsuarioAcessos,
        isLoadingDistribuicaoDiaAcessos,
        isLoadingPerfilUsuariosAcessos,
        isLoadingPorcemPerfilUserAcessos,
        isLoadingPorteAcessos,
        isLoadingTempoMedioAcessos,
        isLoadingUfAcessos,
        isLoadingUfUnicoAcessos,
        // END LOADING ACESSOS----------------------------------------------------------------

        // START LOADING RECORRENCIAS----------------------------------------------------------------
        isLoadingRecorrenciaPjSse,
        isLoadingRecorrenciaPjSas,
        isLoadingRecorrenciaPjMeiSas,
        isLoadingRecorrenciaPjMeSas,
        isLoadingRecorrenciaPjEppSas,
        // END LOADING RECORRENCIAS----------------------------------------------------------------
    };
};

export default DashboardModel;
